
import { getApiBaseUrl, getApiClient } from "./serviceconfig";

var apiBaseUrl = getApiBaseUrl();
// var apiBaseUrl ="http://localhost:8001";
export async function getAllCustomerMain(cookies, searchString) {
  const params = new URLSearchParams();
  if (searchString && typeof searchString === 'string') {
    params.set('name', searchString);
  }
  params.set('limit', '2000');
  const qs = params.toString();
  return getApiClient(cookies)
    .get(`${apiBaseUrl}/customers/${qs ? `?${qs}` : ''}`)
    .then(response => response.data);
}

export async function searchGstin(cookies, gst_no, company_id = null) {
  let url = `${apiBaseUrl}/customers/search_gstin/?gst_no=${encodeURIComponent(gst_no)}`;
  if (company_id) {
    url += `&company_id=${encodeURIComponent(company_id)}`;
  }
  return getApiClient(cookies)
   .get(url)
  .then(response => response.data);
}

export async function createCustomerMain(cookies, inputs) {

  return getApiClient(cookies).post(`${apiBaseUrl}/customers/`,inputs)
  
}

export async function updateCustomerMain(cookies, inputs, customerId) {

    return getApiClient(cookies)
    .put(`${apiBaseUrl}/customers/${customerId}/`,inputs)
}
  


export async function getCustomerMainDetails(cookies, customerId) {

  return getApiClient(cookies).get(`${apiBaseUrl}/customers/${customerId}/`)
  .then(response => response.data)
}

export async function deleteCustomerMain(cookies, customerId) {

  return getApiClient(cookies).delete(
    `${apiBaseUrl}/customers/${customerId}/`)
}